import apiSlice from "../api/apiSlice";

export const dsoApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    /* GET */
    getDsoByCommunityIdPagination: builder.query({
      query: ({ limit, page, date, time, cpe, communityId, sortColumn, sortDirection }) => ({
        url:
          `/communities/${communityId}/dso/pagination?` +
          `limit=${limit}&` +
          `offset=${page * limit}` +
          `${date ? `&date=${date}` : ""}` +
          `${time ? `&time=${time}` : ""}` +
          `${cpe ? `&meter_id=${cpe}` : ""}` +
          `${sortDirection ? `&sort_direction=${sortDirection}` : ""}` +
          `${sortColumn ? `&sort_column=${sortColumn}` : ""}`,
        method: "GET",
      }),
    }),
    getDsoAggregatorByCommunityIdPagination: builder.query({
      query: ({ limit, page, date, time, meter, communityId, sortColumn, sortDirection }) => ({
        url:
          `/communities/${communityId}/dso/aggregator/pagination?` +
          `limit=${limit}&` +
          `offset=${page * limit}` +
          `${date ? `&date=${date}` : ""}` +
          `${time ? `&time=${time}` : ""}` +
          `${meter ? `&meter_id=${meter}` : ""}` +
          `${sortDirection ? `&sort_direction=${sortDirection}` : ""}` +
          `${sortColumn ? `&sort_column=${sortColumn}` : ""}`,
        method: "GET",
      }),
    }),
    getDsoKpisByCommunityId: builder.query({
      query: ({ communityId, startDate, endDate }) => ({
        url:
          `/communities/${communityId}/dso/metrics/kpis?` +
          `start_date=${startDate}&` +
          `end_date=${endDate}`,
        method: "GET",
        validateStatus: (response, result) => response.status === 200 && !result?.isError,
      }),
      providesTags: [{ type: "Metrics", id: "Dso-Kpis" }],
    }),
    getDsoMetricsByCommunityId: builder.query({
      query: ({ communityId, startDate, endDate, granularity }) => ({
        url:
          `/communities/${communityId}/dso/metrics?` +
          `start_date=${startDate}&` +
          `end_date=${endDate}&` +
          `granularity=${granularity}`,
        method: "GET",
        validateStatus: (response, result) => response.status === 200 && !result?.isError,
      }),
      providesTags: [{ type: "Metrics", id: "Dso-Metrics" }],
    }),
    getDsoMetricsMetersByCommunityId: builder.query({
      query: ({ communityId, startDate, endDate, granularity }) => ({
        url:
          `/communities/${communityId}/dso/metrics/meters?` +
          `start_date=${startDate}&` +
          `end_date=${endDate}&` +
          `granularity=${granularity}`,
        method: "GET",
        validateStatus: (response, result) => response.status === 200 && !result?.isError,
      }),
      providesTags: [{ type: "Metrics", id: "Dso-Metrics-Meters" }],
    }),
    getDsoMetersShare: builder.query({
      query: ({ communityId, startDate, endDate }) => ({
        url:
          `/communities/${communityId}/dso/metrics/meters/share?` +
          `start_date=${startDate}&` +
          `end_date=${endDate}`,
        method: "GET",
        validateStatus: (response, result) => response.status === 200 && !result?.isError,
      }),
      providesTags: [{ type: "Metrics", id: "Dso-Meters-Share" }],
    }),
    /* POST */
    addNewDso: builder.mutation({
      query: ({ file, communityId }) => {
        const formData = new FormData();

        formData.append("file_upload", file, file.name);

        return {
          url: `/communities/${communityId}/dso/file_upload`,
          method: "POST",
          body: formData,
        };
      },
      invalidatesTags: [{ type: "DSO", id: "LIST" }],
    }),
  }),
});

export const {
  useGetDsoByCommunityIdPaginationQuery,
  useGetDsoAggregatorByCommunityIdPaginationQuery,
  useAddNewDsoMutation,
  useGetDsoKpisByCommunityIdQuery,
  useGetDsoMetricsByCommunityIdQuery,
  useGetDsoMetricsMetersByCommunityIdQuery,
  useGetDsoMetersShareQuery,
} = dsoApiSlice;
